import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=b4b3ceb0&scoped=true&"
import script from "./Diversity.vue?vue&type=script&lang=js&"
export * from "./Diversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b3ceb0",
  null
  
)

export default component.exports